import React, { Component } from 'react'
import { QueryRenderer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro'
import { withTranslation } from 'react-i18next'
import styled, { createGlobalStyle } from 'styled-components'

import { Conversation } from '../../components'
import environment from '../../Environment'

const GlobalStyle = createGlobalStyle`
  a {
    color: #48b1bf;
    text-decoration: none;
  }
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

class TranslatedConversationPage extends Component {
  state = {
    refetchedAt: new Date()
  }

  onRefreshRequired = () => this.setState({ refetchedAt: new Date() })

  render () {
    const { t, match: { params: { shortId, participantShortId = '' } } } = this.props
    const { refetchedAt } = this.state

    return (
      <QueryRenderer
        environment={environment}
        query={graphql`
          query ConversationPageQuery($shortId: String!, $participantShortId: String!) {
            conversation: conversationByShortId(shortId: $shortId) {
              ...Conversation_conversation
            }

            participant: participantByShortId(shortId: $participantShortId) {
              ...Conversation_participant
            }
          }
        `}
        variables={{ shortId, participantShortId, refetchedAt }}
        render={({ error, props }) => {
          if (error) {
            return (
              <Container>
                <div>{error.message}</div>
                <GlobalStyle />
              </Container>
            )
          }

          if (props) {
            const { conversation, participant } = props
            if (conversation) {
              return (
                <Container>
                  <Conversation
                    conversation={conversation}
                    participant={participant}
                    onRefreshRequired={this.onRefreshRequired} />
                  <GlobalStyle />
                </Container>
              )
            }

            return (
              <Container>
                <div>{'Conversation not found*'}</div>
                <GlobalStyle />
              </Container>
            )
          }

          return (
            <Container>
              <div className='loading'>{t('general_loading')}</div>
              <GlobalStyle />
            </Container>
          )
        }} />
    )
  }
}

const ConversationPage = withTranslation()(TranslatedConversationPage)
export { ConversationPage as Conversation }
